import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';
import { type BlazeSchema } from '@blaze-shared/schema-domain';

import { type DefinitionMapper } from '../../../ai';
import { type CanvasElementDefinition } from '../../../canvas-elements/element-definition';

import { type CheckboxDefinition } from './checkbox.definition';

export class CheckboxDefinitionMapper implements DefinitionMapper<'checkbox'> {
  readonly type = 'checkbox';

  extract(
    element: CanvasElementFrom<'checkbox'>,
    _schemas: Readonly<Record<string, BlazeSchema>>,
    _definition: CanvasElementDefinition<'checkbox'>,
  ): PartialDeep<CheckboxDefinition> {
    const { title, checkbox } = element.props.content;

    return {
      label: title?.label,
      showLabel: title?.enabled,
      iconName: title?.icon,
      tooltip: title?.tooltip,
      isReadOnly: checkbox?.readonly,
      styleName: element.props.styleConfig?.styleName,
    };
  }
}
